import MailListItemAnimationStore from './schema/MailListItemAnimationStore';
import { createStore } from 'satcheljs';

const MailListItemAnimationDefaultStore: MailListItemAnimationStore = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (8,5): Type 'null' is not assignable to type 'ActionId'.
    // @ts-expect-error
    animationAction: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (12,5): Type 'null' is not assignable to type 'Set<string>'.
    // @ts-expect-error
    animationRowIds: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (16,5): Type 'null' is not assignable to type '() => void'.
    // @ts-expect-error
    onAnimationComplete: null,

    prefersMotion: null,
};

export let getStore = createStore<MailListItemAnimationStore>(
    'MailItem',
    MailListItemAnimationDefaultStore
);

export const mailListItemAnimationStore = getStore();
